const attachmentType = {
    BINDER : 'Binder',

    BINDER_COVER_LETTER : 'Binder Cover Letter',

    CORRESPONDENCE : 'Correspondence',

    COVER_LETTER : 'Cover Letter',

    ENDORSEMENT : 'Endorsement',

    GENERATED_SECTION : 'Generated Section',

    ISSUANCE : 'Issuance',

    POLICY : 'Policy',

    PROPOSAL : 'Proposal',

    QUOTE : 'Quote',

    STATIC_SECTION : 'Static Section',

    NOTICE_OF_CANCELLATION : 'Notice of Cancellation'

};

angular.module('gw-um-j2js')
    .constant('attachmentType', attachmentType);